/**
 * Frontmatter splice for inline cell edits. Local to the bases slice (the
 * views slice has an equivalent, but slices are self-contained by design).
 *
 * Computes the minimal splice that replaces ONLY the frontmatter block of a
 * markdown document with `props`: delete `deleteLen` chars at offset 0, then
 * insert `insert`. The body is never touched, so concurrent body edits merge
 * cleanly through Yjs. Applying the splice yields withFrontmatter(current, props).
 */
import { parseFrontmatter, withFrontmatter } from '@rbv/shared';

export function frontmatterSplice(
  current: string,
  props: Record<string, unknown>,
): { deleteLen: number; insert: string } {
  const { bodyStart } = parseFrontmatter(current);
  const full = withFrontmatter(current, props);
  const insert = full.slice(0, parseFrontmatter(full).bodyStart);
  return { deleteLen: bodyStart, insert };
}
